import { inherits as _inherits, createClass as _createClass, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper, defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import { getI18nInstance } from './i18n.js';

var withFrameworkTranslation = function withFrameworkTranslation(namespace) {
  return function (WrappedComponent) {
    return /*#__PURE__*/function (_Component) {
      function _class(props) {
        var _this;
        _classCallCheck(this, _class);
        _this = _callSuper(this, _class, [props]);
        _defineProperty(_this, "setLanguage", function (lang) {
          _this.setState({
            lang: lang
          });
        });
        _defineProperty(_this, "translate", function (key, options) {
          var i18nInstance = getI18nInstance();
          return i18nInstance.t(key, _objectSpread2(_objectSpread2({}, options), {}, {
            ns: _this.nameSpace
          }));
        });
        _this.nameSpace = namespace || 'default';
        getI18nInstance().on('languageChanged', _this.setLanguage);
        _this.state = {
          lang: ''
        };
        return _this;
      }
      _inherits(_class, _Component);
      return _createClass(_class, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({}, this.props, {
            t: this.translate
          }));
        }
      }]);
    }(Component);
  };
};

export { withFrameworkTranslation };
